import React from 'react';
import { Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { modalConfirmationTicketStyles } from '../../styles';
import { formatDateWithoutTime } from '../../../../../../../helpers/DateFormatter';

const ModalDispatchDate = (props) => {
  const { mobile, info } = props;

  const classes = modalConfirmationTicketStyles({ mobile });

  return (
    <>
      <Typography className={classes.bodyText}>
        La fecha seleccionada para reagendar tu compra es:
      </Typography>

      <Typography className={classes.bodyText}>
        <strong>
          {formatDateWithoutTime(new Date(info?.selectedDate?.toString()))}
        </strong>
      </Typography>
    </>
  );
};

ModalDispatchDate.propTypes = {
  mobile: PropTypes.bool,
  info: PropTypes.object,
};

export default ModalDispatchDate;
